import {
  module_versionV4,
  module_versionV8,
} from 'api/services/content/module_version';
import { useHboActivationFlag } from './useHboActivationFlag';

// El module_version de los servicios de CMS depende unicamente del feature flag de activacion
// de HBO: siempre se envia un valor explicito, v8 con el flag activo y v4 con el flag apagado.
// `resolved` queda en true desde el primer render porque useHboActivationFlag es sincrono
// (es un selector sobre metadata, no tiene loading propio).
export const useHboModuleVersion = () => {
  const isFlagEnabled = useHboActivationFlag();

  return {
    moduleVersion: isFlagEnabled ? module_versionV8 : module_versionV4,
    resolved: true,
  };
};
